// Validar que la variable de entorno esté configurada
if (!process.env.REACT_APP_API_URL) {
  throw new Error('❌ REACT_APP_API_URL debe estar definida en las variables de entorno');
}

export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const API_URL = `${API_BASE_URL}/api`; 